export default __webpack_public_path__ + "a917ad5.png";